module.exports = __webpack_public_path__ + "static/media/google.8e196f5c.svg";